import { SIDEBAR_TOGGLE_VISIBILITY } from '../constants/actionTypes';

const initialState = {
	visible: false,
};

export default function activity(state = initialState, action) {
	const { type } = action;

	switch (type) {
		case SIDEBAR_TOGGLE_VISIBILITY:
			return {
				visible: !state.visible,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/sidebar.js